import { render } from "./UserCenter.vue?vue&type=template&id=03520da9&scoped=true"
import script from "./UserCenter.vue?vue&type=script&lang=js"
export * from "./UserCenter.vue?vue&type=script&lang=js"

import "./UserCenter.vue?vue&type=style&index=0&id=03520da9&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-03520da9"]])

export default __exports__